export { RecordDetails } from './ui';
